import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { AsyncJobType } from '@recruitee/account-data';
import { bulkActionEffectFactory } from '@recruitee/async-job-data';

import { LocationsBulkActionsHttpClient } from './bulk-actions-http-client';
import { LocationsBulkActions } from './bulk-actions.store';

@Injectable({ providedIn: 'root' })
export class LocationsBulkEffects {
  public merge$ = bulkActionEffectFactory(
    this.actions$,
    LocationsBulkActions,
    'merge',
    AsyncJobType.BulkLocationsMerge,
    params => this.bulkActionsHttpClient.merge(params),
  );

  constructor(
    public bulkActionsHttpClient: LocationsBulkActionsHttpClient,
    private actions$: Actions,
  ) {}
}
